const {createContext} = require("react")

const TranslateUrlsContext = createContext({})

module.exports = {
  TranslateUrlsContext,
}
